'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { WhatsAppSendProvider } from '@/contexts/whatsapp-send-context';
import { EmailSendProvider } from '@/contexts/email-send-context';
import { CreatorModalProvider } from '@/contexts/creator-modal-context';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { queryClient } from '@/lib/queryClient';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <WhatsAppSendProvider>
          <EmailSendProvider>
            <CreatorModalProvider>
              {children}
              <Toaster />
            </CreatorModalProvider>
          </EmailSendProvider>
        </WhatsAppSendProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
